import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
} from '@/components/ui/navigation-menu';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { Menu, X, Phone } from 'lucide-react';

const Navigation = ({ onOpenContactForm }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const services = [
    { name: 'Trademark Registration', path: '/trademark-registration' },
    { name: 'Copyright Registration', path: '/copyright-registration' },
    { name: 'Company Formation', path: '/company-formation' },
    { name: 'Trademark Search', path: '/trademark-search' },
    { name: 'Amazon Brand Registry', path: '/amazon-brand-registry' },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-white/90 border-b border-slate-200" data-testid="main-navigation">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center space-x-2" data-testid="logo-link">
            <div className="text-2xl font-bold tracking-tight" style={{ fontFamily: 'Outfit, sans-serif', color: '#1E3A8A' }}>
              TRADEMARK COMPANY
            </div>
          </Link>

          <div className="hidden lg:flex items-center space-x-6">
            <a href="#about" className="text-slate-700 font-medium hover:text-[#1E3A8A] transition-colors" data-testid="about-link">
              About
            </a>
            
            <NavigationMenu>
              <NavigationMenuList>
                <NavigationMenuItem>
                  <NavigationMenuTrigger className="text-slate-700 font-medium hover:text-[#1E3A8A]" data-testid="services-menu-trigger">
                    Services
                  </NavigationMenuTrigger>
                  <NavigationMenuContent>
                    <ul className="grid w-[400px] gap-2 p-4 bg-white">
                      {services.map((service) => (
                        <li key={service.path}>
                          <Link
                            to={service.path}
                            className="block select-none p-3 leading-none no-underline outline-none hover:bg-slate-100 transition-colors"
                            data-testid={`service-link-${service.path.replace('/', '')}`}
                          >
                            <div className="text-sm font-medium text-slate-900 hover:text-[#1E3A8A]">
                              {service.name}
                            </div>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </NavigationMenuContent>
                </NavigationMenuItem>
              </NavigationMenuList>
            </NavigationMenu>

            <a href="#pricing" className="text-slate-700 font-medium hover:text-[#1E3A8A] transition-colors" data-testid="pricing-link">
              Pricing
            </a>
            <a href="#faqs" className="text-slate-700 font-medium hover:text-[#1E3A8A] transition-colors" data-testid="faqs-link">
              FAQs
            </a>

            <div className="flex items-center space-x-2 text-slate-700 ml-2">
              <Phone className="h-4 w-4" />
              <span className="font-medium">+1 (123) 123-4567</span>
            </div>

            <Button
              onClick={onOpenContactForm}
              className="bg-[#1E3A8A] hover:bg-[#1E40AF] text-white px-6 py-4 font-semibold hover:-translate-y-0.5 transition-all ml-2"
              data-testid="header-cta-button"
            >
              Get Started
            </Button>
          </div>

          <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
            <SheetTrigger asChild className="lg:hidden">
              <Button variant="ghost" size="icon" data-testid="mobile-menu-trigger">
                <Menu className="h-6 w-6" />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-[300px] sm:w-[400px]">
              <div className="flex flex-col space-y-4 mt-8">
                <div className="text-sm font-semibold text-slate-900 mb-2">Services</div>
                {services.map((service) => (
                  <Link
                    key={service.path}
                    to={service.path}
                    className="text-slate-700 hover:text-slate-900 pl-4"
                    onClick={() => setMobileMenuOpen(false)}
                    data-testid={`mobile-service-link-${service.path.replace('/', '')}`}
                  >
                    {service.name}
                  </Link>
                ))}
                <a href="#about" className="text-slate-700 hover:text-slate-900" onClick={() => setMobileMenuOpen(false)}>
                  About
                </a>
                <a href="#pricing" className="text-slate-700 hover:text-slate-900" onClick={() => setMobileMenuOpen(false)}>
                  Pricing
                </a>
                <a href="#faqs" className="text-slate-700 hover:text-slate-900" onClick={() => setMobileMenuOpen(false)}>
                  FAQs
                </a>
                <Button
                  onClick={() => {
                    setMobileMenuOpen(false);
                    onOpenContactForm();
                  }}
                  className="bg-[#1E3A8A] hover:bg-[#1E40AF] text-white w-full"
                  data-testid="mobile-cta-button"
                >
                  Get Started
                </Button>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
